module.exports = __webpack_public_path__ + "img/unlocked-icon.0677bae7.svg";